import React, { useEffect } from "react";
import { Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsDetailedInsightVisible,
  setDeepDiveInfoLoader,
  setDeepDiveWidgetLoaders,
  setTabClick,
} from "../../../../redux/actions/DeepDive";
import {
  prolificUserDeepDiveArray,
  // localArray,
  getPaneIndex,
  getWindowLocationPath,
  useQuery,
  // getDeepDiveTabList,
} from "../../../../redux/constants";
import { getDeepDive } from "../../../../redux/actions/WidgetMaker/WidgetAPI";
import isEqual from "react-fast-compare";
import { setMarkInfluencersFlag } from "../../../../redux/actions/commandCenter/screens/screen";
const DeepDiveTab = ({ tabId }) => {
  let query = useQuery();
  const dispatch = useDispatch();
  const isDetailedInsightVisible = useSelector(
    (state) => state.DeepDive.isDetailedInsightVisible
  ); //deep dive modal state
  const tabClick = useSelector((state) => state.DeepDive.tabClick);
  const deepdive_object = useSelector(
    (state) => state.WidgetMaker.deepdive_object
  );
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const panes = useSelector((state) => state.Tab1.panes); //all tabs data
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const widgetLoaders = useSelector((state) => state.DeepDive.widgetLoaders);
  const authParams = useSelector((state) => state.Authentication.authParams);
  // const userPrivileges = useSelector(
  //   (state) => state?.ApiCall?.brands?.data?.result?.privileges
  // );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const share_workspace_privileges = useSelector(
    (state) => state.ApiCall.share_workspace_privileges
  );
  const mentions_object = useSelector(
    (state) => state?.WidgetMaker?.deep_dive_mentions_object
  );
  const influencers_object = useSelector(
    (state) => state?.WidgetMaker?.deep_dive_influencers_object
  );
  const screen = useSelector((state) => state?.Screens?.screen);
  let pathName = getWindowLocationPath()?.toLowerCase();
  let index = getPaneIndex(panes, activeKey);

  const localArray =
    workspace_privileges?.environment === 2 ||
    share_workspace_privileges?.environment === 2
      ? [
          { name: "Word Cloud", key: "2" },
          { name: "Category", key: "3" },
          { name: "Influencers", key: "4" },
          { name: "Source of Post", key: "5" },
          { name: "Mentions", key: "1" },
          // { name: "Location Profiles", key: "10" },
        ]
      : [
          { name: "Mentions", key: "1" },
          { name: "Word Cloud", key: "2" },
          { name: "Category", key: "3" },
          { name: "Influencers", key: "4" },
          { name: "Source of Post", key: "5" },
          // { name: "Location Profiles", key: "10" },
        ];
  const getDeepDiveTabList = (userPrivileges) => {
    let tabLists = [...localArray];
    if (userPrivileges) {
      if (userPrivileges?.location_profile_enabled) {
        tabLists = [...tabLists, { name: "Location Profiles", key: "10" }];
      }
    }
    return tabLists;
  };

  const handleOnClick = (event) => {
    dispatch(
      setTabClick({
        tabName:
          event.name === "Mentions"
            ? "mentions"
            : event.name === "Word Cloud"
            ? "wordcloud"
            : event.name === "Category"
            ? "category"
            : event.name === "Influencers"
            ? "influencers"
            : event.name === "Source of Post"
            ? "source_of_post"
            : event.name === "Location Profiles"
            ? "locations"
            : null,
        state: true,
      })
    );

    let index = getPaneIndex(panes, activeKey);

    let deepDiveVisibleObj = { ...isDetailedInsightVisible };
    deepDiveVisibleObj.name = event.name;
    deepDiveVisibleObj.key = event.key;
    dispatch(setIsDetailedInsightVisible(deepDiveVisibleObj));
    let pathName = getWindowLocationPath()?.toLowerCase();

    if (event?.name === "Mentions") {
      let widget_ids = ["1.1", "1.2"];

      if (
        (screen?.markInfluencersFlag &&
          !shareBrands &&
          pathName === "CommandCenter"?.toLowerCase() &&
          screen?.deep_dive?.mentions) ||
        (!shareBrands &&
          pathName === "CommandCenter"?.toLowerCase() &&
          (!screen?.deep_dive?.mentions ||
            screen?.deep_dive?.mentions?.length === 0)) ||
        (!shareBrands &&
          pathName !== "CommandCenter"?.toLowerCase() &&
          (!panes?.[index]?.deep_dive?.mentions ||
            panes?.[index]?.deep_dive?.mentions?.length === 0)) ||
        (shareBrands &&
          (!shareTemplateData?.deep_dive?.mentions ||
            shareTemplateData?.deep_dive?.mentions?.length === 0))
      ) {
        dispatch(setDeepDiveInfoLoader(true));
        dispatch(
          getDeepDive(
            authParams,
            {
              ...mentions_object,
              tabName: event?.name,
              markInfluencerFlag: screen?.markInfluencersFlag,
            },
            widget_ids,
            query?.get("share_id")
          )
        );
        dispatch(setMarkInfluencersFlag(false));
      }
    } else if (event?.name === "Word Cloud") {
      let widget_ids = ["2.1", "2.2", "2.3", "2.4"];
      if (
        (!shareBrands &&
          pathName === "CommandCenter"?.toLowerCase() &&
          screen?.deep_dive?.wordcloud?.length === 0) ||
        (!shareBrands &&
          pathName !== "CommandCenter"?.toLowerCase() &&
          panes?.[index]?.deep_dive?.wordcloud?.length === 0) ||
        (shareBrands && shareTemplateData?.deep_dive?.wordcloud?.length === 0)
      ) {
        dispatch(setDeepDiveInfoLoader(true));
        dispatch(
          getDeepDive(
            authParams,
            { ...deepdive_object, tabName: event?.name },
            widget_ids,
            query?.get("share_id")
          )
        );
      } else {
        let loadingState = [];
        let data =
          pathName === "CommandCenter"?.toLowerCase()
            ? screen?.deep_dive?.wordcloud
            : shareTemplateData
            ? shareTemplateData?.deep_dive?.wordcloud
            : panes?.[index]?.deep_dive?.wordcloud;
        data?.forEach((e, i) => {
          dispatch(setDeepDiveInfoLoader(true));
          dispatch(
            setDeepDiveWidgetLoaders({
              [event?.name]: [...loadingState, { [i]: true }],
            })
          );
          loadingState = [...loadingState, { [i]: true }];
        });
        dispatch(setDeepDiveInfoLoader(false));
      }
    } else if (event?.name === "Category") {
      let widget_ids = ["3.2", "3.3", "3.4", "3.5"];
      if (
        (!shareBrands &&
          pathName === "CommandCenter"?.toLowerCase() &&
          screen?.deep_dive?.category?.length === 0) ||
        (!shareBrands &&
          pathName !== "CommandCenter"?.toLowerCase() &&
          panes?.[index]?.deep_dive?.category?.length === 0) ||
        (shareBrands && shareTemplateData?.deep_dive?.category?.length === 0)
      ) {
        dispatch(setDeepDiveInfoLoader(true));
        dispatch(
          getDeepDive(
            authParams,
            { ...deepdive_object, tabName: event?.name },
            widget_ids,
            query?.get("share_id")
          )
        );
      } else {
        let loadingState = [];
        let data =
          pathName === "CommandCenter"?.toLowerCase()
            ? screen?.deep_dive?.category
            : shareTemplateData
            ? shareTemplateData?.deep_dive?.category
            : panes?.[index]?.deep_dive?.category;
        data?.forEach((e, i) => {
          dispatch(setDeepDiveInfoLoader(true));
          dispatch(
            setDeepDiveWidgetLoaders({
              [event?.name]: [...loadingState, { [i]: true }],
            })
          );
          loadingState = [...loadingState, { [i]: true }];
        });
        dispatch(setDeepDiveInfoLoader(false));
      }
    } else if (event?.name === "Influencers") {
      let widget_ids = ["4.1"];
      if (
        (screen?.markInfluencersFlag &&
          !shareBrands &&
          pathName === "CommandCenter"?.toLowerCase() &&
          screen?.deep_dive?.influencers) ||
        (!shareBrands &&
          pathName === "CommandCenter"?.toLowerCase() &&
          screen?.deep_dive?.influencers?.length === 0) ||
        (!shareBrands &&
          pathName !== "CommandCenter"?.toLowerCase() &&
          panes?.[index]?.deep_dive?.influencers?.length === 0) ||
        (shareBrands && shareTemplateData?.deep_dive?.influencers?.length === 0)
      ) {
        dispatch(setDeepDiveInfoLoader(true));
        if (screen?.markInfluencersFlag) {
          delete influencers_object.deepdive_on.order_by;
          delete influencers_object.filter_by_data;
          influencers_object.filter_by = null;
        }
        dispatch(
          getDeepDive(
            authParams,
            {
              ...influencers_object,
              tabName: event?.name,
              markInfluencerFlag: screen?.markInfluencersFlag,
            },
            widget_ids,
            query?.get("share_id")
          )
        );
        dispatch(setMarkInfluencersFlag(false));
      } else {
        let loadingState = [];
        let data =
          pathName === "CommandCenter"?.toLowerCase()
            ? screen?.deep_dive?.influencers
            : shareTemplateData
            ? shareTemplateData?.deep_dive?.influencers
            : panes?.[index]?.deep_dive?.influencers;
        data?.forEach((e, i) => {
          dispatch(setDeepDiveInfoLoader(true));
          dispatch(
            setDeepDiveWidgetLoaders({
              [event?.name]: [...loadingState, { [i]: true }],
            })
          );
          loadingState = [...loadingState, { [i]: true }];
        });
        dispatch(setDeepDiveInfoLoader(false));
      }
    } else if (event?.name === "Source of Post") {
      let widget_ids = ["5.1", "5.2", "5.3", "5.4"];

      if (
        (!shareBrands &&
          pathName === "CommandCenter"?.toLowerCase() &&
          screen?.deep_dive?.source_of_post?.length === 0) ||
        (!shareBrands &&
          pathName !== "CommandCenter"?.toLowerCase() &&
          panes?.[index]?.deep_dive?.source_of_post?.length === 0) ||
        (shareBrands &&
          shareTemplateData?.deep_dive?.source_of_post?.length === 0)
      ) {
        dispatch(setDeepDiveInfoLoader(true));
        dispatch(
          getDeepDive(
            authParams,
            { ...deepdive_object, tabName: event?.name },
            widget_ids,
            query?.get("share_id")
          )
        );
      } else {
        let loadingState = [];
        let data =
          pathName === "CommandCenter"?.toLowerCase()
            ? screen?.deep_dive?.source_of_post
            : shareTemplateData
            ? shareTemplateData?.deep_dive?.source_of_post
            : panes?.[index]?.deep_dive?.source_of_post;
        data?.forEach((e, i) => {
          dispatch(setDeepDiveInfoLoader(true));
          dispatch(
            setDeepDiveWidgetLoaders({
              [event?.name]: [...loadingState, { [i]: true }],
            })
          );
          loadingState = [...loadingState, { [i]: true }];
        });
        dispatch(setDeepDiveInfoLoader(false));
      }
    } else if (event?.name === "Location Profiles") {
      let widget_ids = ["7.1"];
      if (
        (!shareBrands &&
          pathName === "CommandCenter"?.toLowerCase() &&
          screen?.deep_dive?.locations) ||
        (!shareBrands &&
          pathName === "CommandCenter"?.toLowerCase() &&
          screen?.deep_dive?.locations?.length === 0) ||
        (!shareBrands &&
          pathName !== "CommandCenter"?.toLowerCase() &&
          panes?.[index]?.deep_dive?.locations?.length === 0) ||
        (shareBrands && shareTemplateData?.deep_dive?.locations?.length === 0)
      ) {
        dispatch(setDeepDiveInfoLoader(true));
        dispatch(
          getDeepDive(
            authParams,
            { ...deepdive_object, tabName: event?.name },
            widget_ids,
            query?.get("share_id")
          )
        );
      } else {
        let loadingState = [];
        let data =
          pathName === "CommandCenter"?.toLowerCase()
            ? screen?.deep_dive?.locations
            : shareTemplateData
            ? shareTemplateData?.deep_dive?.locations
            : panes?.[index]?.deep_dive?.locations;
        data?.forEach((e, i) => {
          dispatch(setDeepDiveInfoLoader(true));
          dispatch(
            setDeepDiveWidgetLoaders({
              [event?.name]: [...loadingState, { [i]: true }],
            })
          );
          loadingState = [...loadingState, { [i]: true }];
        });
        dispatch(setDeepDiveInfoLoader(false));
      }
    }
  };

  useEffect(() => {
    let index = getPaneIndex(panes, activeKey);
    let tabResponse =
      pathName === "CommandCenter"?.toLowerCase()
        ? screen?.deep_dive
        : shareBrands
        ? shareTemplateData?.deep_dive
        : panes?.[index]?.deep_dive;
    let tabName =
      workspace_privileges?.environment === 2 ||
      share_workspace_privileges?.environment === 2
        ? tabClick?.tabName === "wordcloud"
          ? "Word Cloud"
          : tabClick?.tabName === "category"
          ? "Category"
          : tabClick?.tabName === "influencers"
          ? "Influencers"
          : tabClick?.tabName === "source_of_post"
          ? "Source of Post"
          : tabClick?.tabName === "mentions"
          ? "Mentions"
          : tabClick?.tabName === "locations"
          ? "Location Profiles"
          : "mentions"
        : tabClick?.tabName === "mentions"
        ? "Mentions"
        : tabClick?.tabName === "wordcloud"
        ? "Word Cloud"
        : tabClick?.tabName === "category"
        ? "Category"
        : tabClick?.tabName === "influencers"
        ? "Influencers"
        : tabClick?.tabName === "source_of_post"
        ? "Source of Post"
        : tabClick?.tabName === "locations"
        ? "Location Profiles"
        : "mentions";
    tabClick?.tabName &&
      (widgetLoaders?.[tabName]?.length ===
        tabResponse?.[tabClick?.tabName]?.length ||
        (tabClick?.tabName === "mentions" &&
          tabResponse?.news_mentions &&
          tabResponse?.mentions)) &&
      dispatch(setTabClick({ ...tabClick, state: false }));
  }, [panes, isDetailedInsightVisible, shareTemplateData, shareBrands, screen]);

  let updatedTabList =
    shareTemplateData?.is_prolific_user_deep_dive ||
    panes?.[index]?.is_prolific_user_deep_dive
      ? prolificUserDeepDiveArray
      : shareBrands && share_workspace_privileges
      ? getDeepDiveTabList(share_workspace_privileges)
      : getDeepDiveTabList(workspace_privileges);
  return (
    <div className="deep_dive_tab">
      {updatedTabList?.map((item) => {
        let tabName =
          workspace_privileges?.environment === 2 ||
          share_workspace_privileges?.environment === 2
            ? tabClick?.tabName === "wordcloud"
              ? "Word Cloud"
              : tabClick?.tabName === "category"
              ? "Category"
              : tabClick?.tabName === "influencers"
              ? "Influencers"
              : tabClick?.tabName === "source_of_post"
              ? "Source of Post"
              : tabClick?.tabName === "mentions"
              ? "Mentions"
              : tabClick?.tabName === "locations"
              ? "Location Profiles"
              : "mentions"
            : tabClick?.tabName === "mentions"
            ? "Mentions"
            : tabClick?.tabName === "wordcloud"
            ? "Word Cloud"
            : tabClick?.tabName === "category"
            ? "Category"
            : tabClick?.tabName === "influencers"
            ? "Influencers"
            : tabClick?.tabName === "source_of_post"
            ? "Source of Post"
            : tabClick?.tabName === "locations"
            ? "Location Profiles"
            : "mentions";
        return (
          <Button
            id={item.key}
            style={{
              opacity: `${
                item?.name === tabName || !tabClick?.state ? "1" : ".5"
              }`,
              pointerEvents: `${!tabClick?.state ? "auto" : "none"}`,
            }}
            className={`tab_items box-shadow-none font-weight500 ${
              item.key === isDetailedInsightVisible?.key ? "active" : ""
            }`}
            onClick={() => handleOnClick(item)}
          >
            {item.name}
          </Button>
        );
      })}
    </div>
  );
};

export default React.memo(DeepDiveTab, isEqual);
